import React, { useState, useEffect } from "react";
import { MdErrorOutline } from "react-icons/md";
import GenerateReport from "../modal/GenerateReport";

export default function DailyProductionReport({
    progressData,
    setStockModal,
    setDateWise,
}) {
    const [loading, setLoading] = useState(false);
    const [itemwiseProduction, setItemwiseProduction] = useState([]);
    const [error, setError] = useState(null);
    const [generateReport, setGenerateReport] = useState(false);
    // Local state for Generate Report modal
    const [showGenerateReport, setShowGenerateReport] = useState(false);
    useEffect(() => {
        if (progressData?.productid) {
            fetchItemwiseProduction(progressData.productid);
        }
    }, [progressData]);

    const fetchItemwiseProduction = async (productId) => {
        setItemwiseProduction([]);
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/itemwise-production/${productId}`
            );

            if (!response.ok) {
                throw new Error("Failed to fetch itemwise production data");
            }

            const data = await response.json();

            setItemwiseProduction(
                Array.isArray(data) ? data : []
            );
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Format date
    const formatDate = (date) => {
        if (!date) return "-";

        const parsedDate = new Date(date);

        if (isNaN(parsedDate.getTime())) {
            return date;
        }

        return parsedDate.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    return (
        <div className="row">

            {/* ================= HEADER ================= */}
            <div className="col-12">
                <div className="d-flex align-items-center gap-3 mb-3">
                    <strong className="fs-5">
                        Daily Production Report
                    </strong>
                </div>
            </div>

            {/* ================= ERROR ================= */}
            {error && (
                <div className="col-12">
                    <div
                        className="alert alert-danger d-flex align-items-center gap-2"
                        role="alert"
                    >
                        <MdErrorOutline size={20} />
                        {error}
                    </div>
                </div>
            )}

            {/* ================= DAILY PRODUCTION STOCK ================= */}
            <div className="col-12 col-md-12 col-lg-12">
                <div className="card p-3 h-100">

                    <div className="d-flex align-items-center justify-content-between gap-3">
                        <strong className="fs-5">
                            {progressData?.productname} Production Stock
                        </strong>

                        <button
                            className="btn btn-dark small-btn text-nowrap"
                            onClick={() => setShowGenerateReport(true)}
                        >
                            Generate Report
                        </button>
                    </div>

                    <div className="table-responsive mt-3">
                        <table className="table table-sm">

                            <thead className="table-light">
                                <tr>
                                    <th>Date</th>
                                    <th>Production Date</th>
                                    <th>Opening</th>
                                    <th>Produced</th>
                                    <th>Dispatched</th>
                                    <th>Rejected</th>
                                    <th>Closing</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {progressData?.productionStock?.length > 0 ? (
                                    progressData.productionStock.map(
                                        (productrow, index) => (
                                            <tr
                                                key={
                                                    productrow?.date ?? index
                                                }
                                            >
                                                <td>
                                                    {formatDate(productrow?.date)}
                                                </td>

                                                <td>
                                                    {productrow?.production_date
                                                        ? formatDate(
                                                            productrow.production_date
                                                        )
                                                        : "No Production"}
                                                </td>

                                                <td>
                                                    {productrow?.opening_stock ?? 0}
                                                </td>

                                                <td>
                                                    {productrow?.stock_in ?? 0}
                                                </td>

                                                <td>
                                                    {productrow?.dispatched_stock ?? 0}
                                                </td>

                                                <td>
                                                    {productrow?.rejected_stock ?? 0}
                                                </td>

                                                <td>
                                                    {productrow?.closing_stock ?? 0}
                                                </td>

                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-secondary"
                                                        onClick={() => {
                                                            setStockModal(true);
                                                            setDateWise(
                                                                productrow?.date
                                                            );
                                                        }}
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    )
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="8"
                                            className="text-center text-muted py-3"
                                        >
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>

            {/* ================= GENERATE REPORT MODAL ================= */}
            <GenerateReport
                show={showGenerateReport}
                handleClose={() =>
                    setShowGenerateReport(false)
                }
            />

        </div>
    );
}